import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
} from "@angular/core";

import { MedLayoutService } from "../../../services/med-layout.service";

const MIN_SCROLLBAR_WIDTH = 0;

@Component({
  selector: "med-layout",
  templateUrl: "./med-layout.component.html",
})
export class MedLayoutComponent implements AfterViewInit, OnChanges {
  constructor(public layoutSvc: MedLayoutService, private cd: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this._verticalScrollbarHandler();
    this.cd.detectChanges();
  }

  ngOnChanges() {
    this._verticalScrollbarHandler();
  }

  private _verticalScrollbarHandler(): void {
    const width =  window.innerWidth - document.body.clientWidth;
    this.layoutSvc.scrollbarWidth = MIN_SCROLLBAR_WIDTH < width ? width : MIN_SCROLLBAR_WIDTH;
  }
}
